module.exports = __webpack_public_path__ + "static/media/Cutiefly_gaussian2.f1b56bb2.png";